/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useState, useEffect } from 'react'
import { redirectFromUtils, RECOVER_PATH } from '../../utils/localStorageUtils'
import { StyledMessage } from './styles'

interface IFeedbackModalProps {
  isError?: boolean
  redirectFrom: string[]
  messages: {
    [key: string]: string
  }
  gap?: string
  children?: React.ReactNode
}

const FeedbackMessage = ({
  redirectFrom = [],
  messages = {},
  children,
  gap,
  isError,
}: IFeedbackModalProps): React.ReactElement => {
  const [message, setMessage] = useState<string>('')

  useEffect(() => {
    if (redirectFromUtils.includes(redirectFrom as RECOVER_PATH[])) {
      handleModalText()
      redirectFromUtils.clear()
    } else if (isError) {
      redirectFromUtils.clear()
    }
  }, [])

  const handleModalText = () => {
    Object.keys(messages).forEach(v => {
      if (redirectFromUtils.get() === v) {
        setMessage(messages[v])
      }
    })
  }

  return message ? (
    <StyledMessage
      type="success"
      inline
      className="Message-root"
      style={{ margin: gap || 0 }}
      onClose={() => setMessage('')}
    >
      {message}
    </StyledMessage>
  ) : (
    <>{children}</>
  )
}

export default FeedbackMessage
